import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CalendarViewDayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"calendar_view_day"}/>
}
